<template>
  <div
    :class="[
      $style.overlayItem,
      open && $style.open
    ]"
  >
    <div
      :class="$style.question"
      @click="open = !open"
    >
      {{ question }}
    </div>
    <div
      :class="$style.answer"
      v-html="answer"
    />
  </div>
</template>

<style lang="scss" module>

.overlayItem {
  margin-bottom: 30px;
}

.question {
  font-size: 1.4rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.6px;
  color: $color-text;
  cursor: pointer;

  &:hover,
  .open & {
    color: $color-text--light;
  }
}

.answer {
  margin-top: 15px;
  border-radius: 5px;
  background-color: #f7f7f7;
  padding: 20px;
  font-size: 1.4rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: 0.2px;
  color: $color-text;
  display: none;

  .open & {
    display: block;
  }

  a {
    color: #e73273;
    text-decoration: underline;
    font-weight: normal;
    cursor: pointer;
  }
}

</style>

<script>

export default {
  props: {
    question: {
      type: String,
      required: true,
    },
    answer: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      open: false,
    };
  },
};

</script>
